// "Cadastrar novo cliente" do BALCÃO (pedido do dono, 29/09/2026): os mesmos
// campos do cadastro das Mesas — nome (obrigatório), telefone, CPF e
// nascimento. Grava em POST /clientes e devolve o cliente criado, que já fica
// escolhido no pedido. Enter no último campo cadastra.
import { UserPlus } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { totemApi } from "../api";

const soDigitos = (v) => String(v || "").replace(/\D/g, "");
const telefone = (v) => {
  const n = soDigitos(v).slice(0, 11);
  if (n.length <= 2) return n ? `(${n}` : "";
  if (n.length <= 3) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
  if (n.length <= 7) return `(${n.slice(0, 2)}) ${n.slice(2, 3)}.${n.slice(3)}`;
  return `(${n.slice(0, 2)}) ${n.slice(2, 3)}.${n.slice(3, 7)}-${n.slice(7)}`;
};
const cpf = (v) => soDigitos(v).slice(0, 11)
  .replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");

export default function CadastroClienteDialog({ aberto, sugestao = "", onFechar, onCriado }) {
  const [dados, setDados] = useState({ nome: "", telefone: "", cpf: "", nascimento: "" });
  const [salvando, setSalvando] = useState(false);
  // O que foi digitado na busca já entra no campo certo: número → telefone (ou CPF), texto → nome.
  useEffect(() => {
    if (!aberto) return;
    const d = soDigitos(sugestao);
    const soNumero = d && !/[a-zA-ZÀ-ú]/.test(sugestao);
    const ehCpf = soNumero && d.length === 11 && d[2] !== "9"; // 11 dígitos sem o 9 do celular
    setDados({ nome: soNumero ? "" : sugestao.trim(), telefone: soNumero && !ehCpf ? telefone(d) : "", cpf: ehCpf ? cpf(d) : "", nascimento: "" });
  }, [aberto, sugestao]);
  const mudar = (campo, valor) => setDados((x) => ({ ...x, [campo]: valor }));
  const cadastrar = async () => {
    const nome = dados.nome.trim();
    if (!nome) { toast.error("Informe o nome do cliente."); return; }
    setSalvando(true);
    try {
      const { data } = await totemApi.criarCliente({
        nome, telefone: dados.telefone.trim() || null, cpf: dados.cpf.trim() || null, data_nascimento: dados.nascimento || null,
      });
      toast.success("Cliente cadastrado!");
      onCriado(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao cadastrar cliente.");
    } finally {
      setSalvando(false);
    }
  };
  const enter = (e) => { if (e.key === "Enter") { e.preventDefault(); cadastrar(); } };
  const campo = "h-11 bg-zinc-800 border-zinc-700 text-zinc-100 placeholder:text-zinc-500";
  return (
    <Dialog open={aberto} onOpenChange={(v) => { if (!v) onFechar(); }}>
      <DialogContent className="sm:max-w-md bg-zinc-900 border border-zinc-700 text-zinc-100 rounded-2xl" data-e2e="dialog-cadastro-cliente">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-zinc-100"><UserPlus className="w-5 h-5 text-orange-500" /> Cadastrar novo cliente</DialogTitle>
        </DialogHeader>
        <div className="space-y-3" onKeyDown={enter}>
          <div><label className="text-xs text-zinc-400">Nome *</label>
            <Input autoFocus value={dados.nome} onChange={(e) => mudar("nome", e.target.value)} placeholder="Nome completo" className={campo} data-e2e="cadastro-nome" /></div>
          <div><label className="text-xs text-zinc-400">Telefone</label>
            <Input value={dados.telefone} onChange={(e) => mudar("telefone", telefone(e.target.value))} placeholder="(00) 0.0000-0000" inputMode="numeric" className={campo} data-e2e="cadastro-telefone" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="text-xs text-zinc-400">CPF</label>
              <Input value={dados.cpf} onChange={(e) => mudar("cpf", cpf(e.target.value))} placeholder="000.000.000-00" inputMode="numeric" className={campo} /></div>
            <div><label className="text-xs text-zinc-400">Nascimento</label>
              <Input type="date" value={dados.nascimento} onChange={(e) => mudar("nascimento", e.target.value)} className={campo} /></div>
          </div>
        </div>
        <div className="flex gap-3 mt-2">
          <button type="button" onClick={onFechar} className="flex-1 h-12 rounded-xl bg-zinc-800 hover:bg-zinc-700 text-zinc-200 font-bold">Cancelar</button>
          <button type="button" onClick={cadastrar} disabled={salvando || !dados.nome.trim()} data-e2e="cadastro-salvar"
            className="flex-1 h-12 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold disabled:opacity-50">{salvando ? "Cadastrando…" : "Cadastrar"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
